/**
 *  Format JS date into WF format
 *
 * @param {string|integer} timestamp date that is to be formatted
 * @param {boolean} isSmallDevice current device is mobile or desktop, default is desktop
 * @return {string} the formatted date string, MM/DD/YY for Desktop and MM/YY for mobile
 */
export const getFormattedDate = (timestamp, isSmallDevice = false) => {
	const d = new Date(timestamp);
	if (isSmallDevice)
		return (
			d.getMonth() +
			1 +
			"/" +
			d
				.getFullYear()
				.toString()
				.substr(2)
		);
	return (
		d.getMonth() +
		1 +
		"/" +
		d.getDate() +
		"/" +
		d
			.getFullYear()
			.toString()
			.substr(2)
	);
};

/**
 * Format JS date into UTC YYYY-MM-DD HH:MM:SS string, for use in data aggregation.
 * @param {string|integer} timestamp date that is to be formatted
 * @return {string} the UTC date string in YYYY-MM-DD HH:MM:SS format
 */
export const getDataFormattedUTCDate = (timestamp) => {
	const x = new Date(timestamp);

	const d = [
		x.getUTCFullYear(),
		x.getUTCMonth() + 1,
		x.getUTCDate(),
		x.getUTCHours(),
		x.getUTCMinutes(),
		x.getUTCSeconds(),
	];
	d.forEach((a, i) => {
		let b = a.toString();
		d[i] = b.length > 1 ? b : `0${b}`;
	});

	return `${d[0]}-${d[1]}-${d[2]} ${d[3]}:${d[4]}:${d[5]}`;
};

/**
 * Takes a short date code (either YYMM or YYMMDD) and returns a formatted date
 * string for display. This is currently primarily used in the Wordle Answers and
 * Wordle Hints pages.
 * @param {string} dateCode The datecode. Should be either in YYMM or YYMMDD format.
 * @param {boolean} isSmallDevice Whether device is mobile or not. Defaults to true.
 * @returns {{year: string, month: string, day: string, formatted: string}} The formatted date string.
 */
export const getDateDataFromDateCode = (
	dateCode = "",
	isSmallDevice = true
) => {
	if (typeof dateCode !== "string") {
		console.warn(
			"Invalid date parameter provided, string required",
			dateCode
		);
		return {};
	}

	const months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];

	const shortRegex = /^\d{4}$/;
	const longRegex = /^\d{6}$/;

	if (!shortRegex.test(dateCode) && !longRegex.test(dateCode)) {
		console.warn(
			"Date parameter has invalid format, YYMMDD or YYMM required",
			dateCode
		);
		return {};
	}

	const isDayDate = longRegex.test(dateCode);

	const output = {
		year: `20${dateCode.substr(0, 2)}`,
		month: months[parseInt(dateCode.substr(2, 2)) - 1],
	};

	if (isDayDate) {
		output.day = dateCode.substr(4, 2);

		if (isSmallDevice) {
			output.formatted = `${output.month.substr(0, 3)}. ${output.day}`;
		} else {
			output.formatted = `${output.month} ${output.day}, ${output.year}`;
		}
	} else {
		output.formatted = `${output.month} ${output.year}`;
	}

	return output;
};
